import safePerformanceMark from './safePerformanceMark';

/**
 * Creates a performance marker with the given measureName plus the "_s" suffix
 * If the measure name already exists, a new entry with same name and updated time is created, exisiting entry still remains
 */
export default function safePerformanceMarkStart(measureName: string): void {
    safePerformanceMark(`${measureName}_s`);
}
